import { Component, Inject, Input, OnInit } from '@angular/core';
import { UntypedFormControl, UntypedFormGroup, Validators } from '@angular/forms';
import { MatDialog, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { NotifierService } from 'angular-notifier';
import { NgxSpinnerService } from 'ngx-spinner';
import { Globals } from 'src/app/service/global';
import { MeetingService } from 'src/app/service/meeting.service';

@Component({
  selector: 'app-save-template-dialog',
  templateUrl: './save-template-dialog.component.html',
  styleUrls: ['./save-template-dialog.component.css']
})
export class SaveTemplateDialogComponent implements OnInit {
  categoryShow = false;
  categoryName=true;
  categoryError=false;
  categoryType: any = <any>[];
  states: string[] = [
  //'All Template',
  'Basic Template',
  'Professional Template',
  ];
   meetingTemplateJson: any;
   meetingData: any;
   meetingId:any;
   meetingStartTime: any;
   meetingTitle : any;
   includeAttendee = true;
   includeAgenda = true;
   newMeetingTitle:any;
   location:any;
   facilitator:any;
   attendees:any;
   agendas:any;
   isSubmitted  =  false;
   selected:any;
   isLoading: boolean = false;
   private readonly notifier!: NotifierService;
   templateForm = new UntypedFormGroup({
    templateName: new UntypedFormControl('',Validators.required),
    categoryStates: new UntypedFormControl('',Validators.required),
    templateDesc: new UntypedFormControl(''),
    categoryName: new UntypedFormControl('',Validators.required),
    participants:new UntypedFormControl([true]),
   notes:new UntypedFormControl([true])
})
  constructor(notifierService: NotifierService,public globals:Globals,@Inject(MAT_DIALOG_DATA) data: any,private dialog: MatDialog,private meetingService: MeetingService,private spinner: NgxSpinnerService) {
   this.isLoading=true;
    this.meetingData = data;
    this.meetingId = data.meetingResponse.meetingId;
    this.meetingStartTime = data.meetingResponse.meetingStartTime;
    this.meetingTitle = data.meetingResponse.meetingTitle;
    this.newMeetingTitle = data.meetingResponse.meetingTitle;
    this.facilitator=data.meetingResponse.facilitator;
    this.notifier = notifierService;
    var categoryReq = {"orgCode":localStorage.getItem("orgCode"),"userId":localStorage.getItem("userId")};
    this.meetingService.loadCategory(categoryReq).subscribe((response:any) => {
        this.categoryType = response.body;
        this.selected=this.categoryType[0]['codeId'];
        this.isLoading=false;
      });
   }
  
  ngOnInit(): void {
    this.templateForm.controls.categoryName.disable();   
  }
  isopenCategory(data:any){
    
    this.categoryShow = !this.categoryShow;
    this.categoryName=false;
    this.categoryError=false;
    if(data==true){
      
      this.templateForm.controls.categoryStates.disable();
      this.templateForm.controls.categoryName.enable();
    }
    else{
      this.templateForm.controls.categoryStates.enable();
    }
    //this.templateForm.controls['categoryStates'].disable();
    //document.getElementById('category-select')?.setAttribute('class','templaedisbale');
  ///  document.getElementById('category-selectone')?.setAttribute('class','templaedisbaleone');
   let categoryBtn = <HTMLElement>document.getElementById('category-btn');
   categoryBtn.style.display = 'none';
   let categorySelectoneField = <HTMLElement>document.getElementById('category-selectone-field');
   categorySelectoneField.style.display = 'none'
    // categoryBtn.setAttribute('style','background-color: rgb(233, 233, 233) !important;')
   }
  get formControls() {
    return this.templateForm.controls;
    }
saveMeetingTemplate() {
  this.isSubmitted = true;
  
  if(this.templateForm.invalid){
   
    return;
  }
 // this.categoryError=false;
 
  this.saveTemplate(this.templateForm.value);
  this.spinner.show();
}
 saveTemplate(data:any){
  var includeAttendee:any='Y';
  var notes;
  if(data.participants[0]==true){
    includeAttendee="Y";
   }
   else{
    includeAttendee="N";
   }
   if(data.notes[0]==true){
    notes="Y";
   }
   else{
    notes="N";
   }
  if(data.categoryStates!=null && data.categoryStates!=""){
    
    this.meetingTemplateJson  = {
      "meetingId":this.meetingId,
      "createdBy":this.globals.userId,
      "userId":this.globals.userId,
      "isTemplate":"Y",
      "templateName": data.templateName,
      "fkCategory":data.categoryStates,
      "description":data.templateDesc,
      "visitorTimeZone":this.globals.vTimeZone,
      "includeAttendee":includeAttendee,
      "includeNotes":notes,
      "meetingTitle":this.meetingTitle,
      "orgCode":localStorage.getItem("orgCode")
    }
  }
  else{
    this.meetingTemplateJson  = {
      "meetingId":this.meetingId,
      "createdBy":this.globals.userId,
      "userId":this.globals.userId,
      "isTemplate":"Y",
      "templateName": data.templateName,
      "categoryName":data.categoryName,
      "description":data.templateDesc,
      "visitorTimeZone":this.globals.vTimeZone,
      "includeAttendee":includeAttendee,
      "includeNotes":notes,
      "meetingTitle":this.meetingTitle,
      "orgCode":localStorage.getItem("orgCode")
    }
  }
    
    this.meetingService.saveAsTemplate(this.meetingTemplateJson).subscribe(response => {
        
        this.notifier.notify("success","Template saved successfully");
        this.spinner.hide();
        this.dialog.closeAll();
 
    });
 }
 
}
